import { GlobalState } from 'ha/types/store';
import { City } from 'ha/services/apiV2/types';

import { STATE_NAME } from '../constants';
import { CityListingsCountsMap } from '../types';

export { default as getInitialValues } from './getInitialValues';

export const getListingsCounts = (state: GlobalState): CityListingsCountsMap =>
  state[STATE_NAME].listings.counts;

export const getCities = (state: GlobalState): City[] =>
  state[STATE_NAME].cities.list;
